export default __webpack_public_path__ + "static/media/person2.6d1f75fa.jpg";